import { useCallback, useEffect, useState } from 'react'
import { crud } from '@think-internet/zeus-frontend-package'
import { NAWSurvey } from '../../../types/NAW/Survey'
import props from '../../../redux/props'

type Pull = () => Promise<void>

const useLoadNAWSurveys = (): [NAWSurvey[] | null, Pull] => {
  const surveyFeature = crud.use(props.NAW_SURVEY)
  const [surveys, setSurveys] = useState<NAWSurvey[]>(null)

  const pull = useCallback(async () => {
    const surveys = await surveyFeature.list({})
    if (surveys) {
      setSurveys(surveys)
    }
  }, [surveyFeature])

  useEffect(() => {
    if (!surveys) pull()
  }, [surveys, pull])

  return [surveys, pull]
}

export default useLoadNAWSurveys
